export const NO_IMAGE = 'null';
/*
"NO_IMAGE"  is used when in "Top Tab"
we are mixed text and images or use only text
src\lib\apps\header\components\TopTabs.js
src\lib\apps\ospHeader\components\TopTabs.js
*/
